import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DEVICE_LABEL_HEADER } from 'src/app/shared/constants/device-label-header';
import { UserAgentService } from 'src/app/shared/services/user-agent.service';

/**
 * Envía la etiqueta de dispositivo en X-Device-Label; User-Agent permanece nativo (lo añade el navegador).
 */
@Injectable()
export class UserAgentInterceptor implements HttpInterceptor {
	private readonly userAgentService = inject(UserAgentService);

	public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		if (!this.shouldAttachDeviceLabel(req.url)) {
			return next.handle(req);
		}

		const deviceLabel = this.userAgentService.getDeviceLabel()?.trim();
		if (!deviceLabel) {
			return next.handle(req);
		}

		return next.handle(
			req.clone({
				setHeaders: {
					[DEVICE_LABEL_HEADER]: deviceLabel,
				},
			}),
		);
	}

	private shouldAttachDeviceLabel(url: string): boolean {
		const apiBase = environment.identity2;
		return Boolean(apiBase && url.includes(apiBase));
	}
}
